<template>
  <div>
    <b-form-group
      :label="`${$getVisibleNames(
        'manual.titulo_profesional',
        false,
        'Título Profesional'
      )}:`"
      label-for="input-professional_title"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <div class="d-flex">
        <div
          class="form-description mb-2"
          @click="$bvModal.show(`edit-professional_title-modal`)"
        >
          <RenderVHtml
            v-b-tooltip.v-secondary.noninteractive.hover="{
              title: $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'manual.titulo_profesional',
                  false,
                  'Título Profesional'
                ),
              }),
              boundary: 'viewport',
            }"
            :content="teaching_profile.professional_title"
          ></RenderVHtml>
        </div>
        <ButtonSmall
          v-if="teaching_profile.professional_title"
          tabindex="-1"
          :tooltip_text="$t('reusable.common.clear')"
          :click_button="
            () => {
              teaching_profile.professional_title = '';
            }
          "
          :class="`ml-1`"
          :icon="'clean'"
        ></ButtonSmall>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-professional_title-modal`"
        :title_modal="
          $t('reusable.common.editTooltip', {
            entity: $getVisibleNames(
              'manual.titulo_profesional',
              false,
              'Título Profesional'
            ),
          })
        "
        :size_modal="`lg`"
        :object_rich_text="teaching_profile"
        :content_rich_text="teaching_profile.professional_title"
        :show_last_modification="true"
        :permit_blank="true"
        @save="(content) => patchProfessionalTitle(teaching_profile, content)"
        @close="$bvModal.hide(`edit-professional_title-modal`)"
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-professional_title-modal`"
        :title="`Editar ${$getVisibleNames(
          'manual.titulo_profesional',
          false,
          'Título Profesional'
        )}`"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Text="teaching_profile.professional_title"
          @save="patchProfessionalTitle"
          :permit_blank="true"
          @close="$bvModal.hide(`edit-professional_title-modal`)"
        ></NewRichTextEditor>
      </b-modal> -->
      <b-form-invalid-feedback id="input-professional_title-live-feedback">
        {{ $t("reusable.common.minLength", { min: 5 }) }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="`${$getVisibleNames(
        'manual.grado_academico',
        false,
        'Grado Académico'
      )}:`"
      label-for="input-academic_degree"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <div class="d-flex">
        <div
          class="form-description mb-2"
          @click="$bvModal.show(`edit-academic_degree-modal`)"
        >
          <RenderVHtml
            v-b-tooltip.v-secondary.noninteractive.hover="{
              title: $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'manual.grado_academico',
                  false,
                  'Grado Académico'
                ),
              }),
              boundary: 'viewport',
            }"
            :content="teaching_profile.academic_degree"
          ></RenderVHtml>
        </div>
        <ButtonSmall
          v-if="teaching_profile.academic_degree"
          tabindex="-1"
          :tooltip_text="$t('reusable.common.clear')"
          :click_button="
            () => {
              teaching_profile.academic_degree = '';
            }
          "
          :class="`ml-1`"
          :icon="'clean'"
        ></ButtonSmall>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-academic_degree-modal`"
        :title_modal="
          $t('reusable.common.editTooltip', {
            entity: $getVisibleNames(
              'manual.grado_academico',
              false,
              'Grado Académico'
            ),
          })
        "
        :size_modal="`lg`"
        :object_rich_text="teaching_profile"
        :content_rich_text="teaching_profile.academic_degree"
        :show_last_modification="true"
        :permit_blank="true"
        @save="(content) => patchAcademicDegree(teaching_profile, content)"
        @close="$bvModal.hide(`edit-academic_degree-modal`)"
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-academic_degree-modal`"
        :title="`Editar ${$getVisibleNames(
          'manual.grado_academico',
          false,
          'Grado Académico'
        )}`"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Text="teaching_profile.academic_degree"
          @save="patchAcademicDegree"
          :permit_blank="true"
          @close="$bvModal.hide(`edit-academic_degree-modal`)"
        ></NewRichTextEditor>
      </b-modal> -->
      <b-form-invalid-feedback id="input-academic_degree-live-feedback">
        {{ $t("reusable.common.minLength", { min: 5 }) }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="`${$getVisibleNames(
        'manual.especializacion',
        false,
        'Especialización'
      )}:`"
      label-for="input-specialization"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <div class="d-flex">
        <div
          class="form-description mb-2"
          @click="$bvModal.show(`edit-specialization-modal`)"
        >
          <RenderVHtml
            v-b-tooltip.v-secondary.noninteractive.hover="{
              title: $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'manual.especializacion',
                  false,
                  'Especialización'
                ),
              }),
              boundary: 'viewport',
            }"
            :content="teaching_profile.specialization"
          ></RenderVHtml>
        </div>
        <ButtonSmall
          v-if="teaching_profile.specialization"
          tabindex="-1"
          :tooltip_text="$t('reusable.common.clear')"
          :click_button="
            () => {
              teaching_profile.specialization = '';
            }
          "
          :class="`ml-1`"
          :icon="'clean'"
        ></ButtonSmall>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-specialization-modal`"
        :title_modal="
          $t('reusable.common.editTooltip', {
            entity: $getVisibleNames(
              'manual.especializacion',
              false,
              'Especialización'
            ),
          })
        "
        :size_modal="`lg`"
        :object_rich_text="teaching_profile"
        :content_rich_text="teaching_profile.specialization"
        :show_last_modification="true"
        :permit_blank="true"
        @save="(content) => patchSpecialization(teaching_profile, content)"
        @close="$bvModal.hide(`edit-specialization-modal`)"
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-specialization-modal`"
        :title="`Editar ${$getVisibleNames(
          'manual.especializacion',
          false,
          'Especialización'
        )}`"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Text="teaching_profile.specialization"
          @save="patchSpecialization"
          :permit_blank="true"
          @close="$bvModal.hide(`edit-specialization-modal`)"
        ></NewRichTextEditor>
      </b-modal> -->
      <b-form-invalid-feedback id="input-specialization-live-feedback">
        {{ $t("reusable.common.minLength", { min: 5 }) }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="`${$getVisibleNames(
        'manual.habilidades_requeridas',
        true,
        'Habilidades Requeridas'
      )}:`"
      label-for="input-required_skills"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <div class="d-flex">
        <div
          class="form-description mb-2"
          @click="$bvModal.show(`edit-required_skills-modal`)"
        >
          <RenderVHtml
            v-b-tooltip.v-secondary.noninteractive.hover="{
              title: $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'manual.habilidades_requeridas',
                  true,
                  'Habilidades Requeridas'
                ),
              }),
              boundary: 'viewport',
            }"
            :content="teaching_profile.required_skills"
          ></RenderVHtml>
        </div>
        <ButtonSmall
          v-if="teaching_profile.required_skills"
          tabindex="-1"
          :tooltip_text="$t('reusable.common.clear')"
          :click_button="
            () => {
              teaching_profile.required_skills = '';
            }
          "
          :class="`ml-1`"
          :icon="'clean'"
        ></ButtonSmall>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-required_skills-modal`"
        :title_modal="
          $t('reusable.common.editTooltip', {
            entity: $getVisibleNames(
              'manual.habilidades_requeridas',
              true,
              'Habilidades Requeridas'
            ),
          })
        "
        :size_modal="`lg`"
        :object_rich_text="teaching_profile"
        :content_rich_text="teaching_profile.required_skills"
        :show_last_modification="true"
        :permit_blank="true"
        @save="(content) => patchRequiredSkills(teaching_profile, content)"
        @close="$bvModal.hide(`edit-required_skills-modal`)"
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-required_skills-modal`"
        :title="`Editar ${$getVisibleNames(
          'manual.habilidades_requeridas',
          true,
          'Habilidades Requeridas'
        )}`"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Text="teaching_profile.required_skills"
          @save="patchRequiredSkills"
          :permit_blank="true"
          @close="$bvModal.hide(`edit-required_skills-modal`)"
        ></NewRichTextEditor>
      </b-modal> -->
      <b-form-invalid-feedback id="input-required_skills-live-feedback">
        {{ $t("reusable.common.minLength", { min: 5 }) }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      :label="`${$getVisibleNames(
        'manual.vigencia_experiencia_laboral',
        false,
        'Vigencia Experiencia Laboral'
      )}:`"
      label-for="input-work_experience_validity"
      label-cols="4"
      label-cols-sm="3"
      class="label"
    >
      <div class="d-flex">
        <div
          class="form-description mb-2"
          @click="$bvModal.show(`edit-work_experience_validity-modal`)"
        >
          <RenderVHtml
            v-b-tooltip.v-secondary.noninteractive.hover="{
              title: $t('reusable.common.editTooltip', {
                entity: $getVisibleNames(
                  'manual.vigencia_experiencia_laboral',
                  false,
                  'Vigencia Experiencia Laboral'
                ),
              }),
              boundary: 'viewport',
            }"
            :content="teaching_profile.work_experience_validity"
          ></RenderVHtml>
        </div>
        <ButtonSmall
          v-if="teaching_profile.work_experience_validity"
          tabindex="-1"
          :tooltip_text="$t('reusable.common.clear')"
          :click_button="
            () => {
              teaching_profile.work_experience_validity = '';
            }
          "
          :class="`ml-1`"
          :icon="'clean'"
        ></ButtonSmall>
      </div>
      <ContainerRichTextKlv3
        :id_modal="`edit-work_experience_validity-modal`"
        :title_modal="
          $t('reusable.common.editTooltip', {
            entity: $getVisibleNames(
              'manual.vigencia_experiencia_laboral',
              false,
              'Vigencia Experiencia Laboral'
            ),
          })
        "
        :size_modal="`lg`"
        :object_rich_text="teaching_profile"
        :content_rich_text="teaching_profile.work_experience_validity"
        :show_last_modification="true"
        :permit_blank="true"
        @save="
          (content) => patchWorkExperienceValidity(teaching_profile, content)
        "
        @close="$bvModal.hide(`edit-work_experience_validity-modal`)"
      >
      </ContainerRichTextKlv3>
      <!-- <b-modal
        :id="`edit-work_experience_validity-modal`"
        :title="`Editar ${$getVisibleNames(
          'manual.vigencia_experiencia_laboral',
          false,
          'Vigencia Experiencia Laboral'
        )}`"
        size="lg"
        hide-footer
      >
        <NewRichTextEditor
          :Text="teaching_profile.work_experience_validity"
          @save="patchWorkExperienceValidity"
          :permit_blank="true"
          @close="$bvModal.hide(`edit-work_experience_validity-modal`)"
        ></NewRichTextEditor>
      </b-modal> -->
      <b-form-invalid-feedback
        id="input-work_experience_validity-live-feedback"
      >
        {{ $t("reusable.common.minLength", { min: 5 }) }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="
        (institution && institution.internal_use_id != 'duoc.cl') ||
        teaching_profile.total_hours > 0
      "
      :label="`${$getVisibleNames(
        'manual.total_pedagogical_hours',
        true,
        'Total de Horas Pedagógicas'
      )}:`"
      label-for="input-total_hours"
      label-cols="0"
      label-cols-sm="3"
      class="m-0 p-0"
    >
      <div class="d-flex">
        <div class="w-100">
          <b-form-input
            id="input-total_hours"
            type="number"
            class="mt-1"
            min="0"
            v-model="$v.teaching_profile.total_hours.$model"
            :state="validateState('total_hours')"
            aria-describedby="input-total_hours-feedback"
            :disabled="institution && institution.internal_use_id == 'duoc.cl'"
            size="sm"
          ></b-form-input>
          <div class="hours-aviable" v-if="maxTotalHours >= 0">
            {{ $t("reusable.common.hoursAvailable") }}:
            <span
              :class="{
                'colorup-hours-available': maxTotalHours > 0,
                'colordown-hours-available': maxTotalHours <= 0,
              }"
              >{{ maxTotalHours > 0 ? maxTotalHours : 0 }}</span
            >
          </div>
          <b-form-invalid-feedback id="input-total_hours-feedback">
            {{ $t("reusable.common.mustEnterHourGreaterOrEqualZero") }}
            <span
              v-if="
                teaching_profile.total_hours && teaching_profile.total_hours > 0
              "
            >
              {{
                $t("reusable.common.cannotExceedHours", {
                  hours:
                    parseFloat(maxTotalHours) +
                    parseFloat(teaching_profile.total_hours),
                })
              }}
            </span>
          </b-form-invalid-feedback>
        </div>
      </div>
    </b-form-group>

    <b-form-group
      v-if="
        institution &&
        institution.internal_use_id == 'duoc.cl' &&
        (teaching_profile.total_theory_hours > 0 || totalClassHours > 0)
      "
      :label="`${$t('matterProgram.matterProgramView.theoryHours')}:`"
      label-for="input-total_theory_hours"
      label-cols="0"
      label-cols-sm="3"
      class="m-0 p-0"
    >
      <div class="d-flex">
        <div class="w-100">
          <b-form-input
            id="input-total_theory_hours"
            type="number"
            class="mt-1"
            min="0"
            v-model="$v.teaching_profile.total_theory_hours.$model"
            :state="validateState('total_theory_hours')"
            aria-describedby="input-total_theory_hours-feedback"
            size="sm"
          ></b-form-input>
          <div class="hours-aviable" v-if="maxTeoryHours >= 0">
            {{ $t("reusable.common.hoursAvailable") }}:
            <span
              :class="{
                'colorup-hours-available': maxTeoryHours > 0,
                'colordown-hours-available': maxTeoryHours <= 0,
              }"
              >{{ maxTeoryHours > 0 ? maxTeoryHours : 0 }}</span
            >
          </div>
          <b-form-invalid-feedback id="input-total_theory_hours-feedback">
            {{ $t("reusable.common.mustEnterHourGreaterOrEqualZero") }}
            <span
              v-if="
                teaching_profile.total_theory_hours &&
                teaching_profile.total_theory_hours > 0
              "
            >
              {{
                $t("reusable.common.cannotExceedHours", {
                  hours:
                    parseFloat(maxTeoryHours) +
                    parseFloat(teaching_profile.total_theory_hours),
                })
              }}
            </span>
          </b-form-invalid-feedback>
        </div>
      </div>
    </b-form-group>
    <b-form-group
      v-if="
        institution &&
        institution.internal_use_id == 'duoc.cl' &&
        (teaching_profile.total_practical_hours > 0 || totalPracticalHours > 0)
      "
      :label="`${$t('matterProgram.matterProgramView.practicalHours')}:`"
      label-for="input-total_practical_hours"
      label-cols="0"
      label-cols-sm="3"
      class="m-0 p-0"
    >
      <div class="d-flex">
        <div class="w-100">
          <b-form-input
            id="input-total_practical_hours"
            type="number"
            class="mt-1"
            min="0"
            v-model="$v.teaching_profile.total_practical_hours.$model"
            :state="validateState('total_practical_hours')"
            aria-describedby="input-total_practical_hours-feedback"
            size="sm"
          ></b-form-input>
          <div class="hours-aviable" v-if="maxPracticalHours >= 0">
            {{ $t("reusable.common.hoursAvailable") }}:
            <span
              :class="{
                'colorup-hours-available': maxPracticalHours > 0,
                'colordown-hours-available': maxPracticalHours <= 0,
              }"
              >{{ maxPracticalHours > 0 ? maxPracticalHours : 0 }}</span
            >
          </div>
          <b-form-invalid-feedback id="input-total_practical_hours-feedback">
            {{ $t("reusable.common.mustEnterHourGreaterOrEqualZero") }}
            <span
              v-if="
                teaching_profile.total_practical_hours &&
                teaching_profile.total_practical_hours > 0
              "
            >
              {{
                $t("reusable.common.cannotExceedHours", {
                  hours:
                    parseFloat(maxPracticalHours) +
                    parseFloat(teaching_profile.total_practical_hours),
                })
              }}
            </span></b-form-invalid-feedback
          >
        </div>
      </div>
    </b-form-group>
    <b-form-group
      v-if="
        institution &&
        institution.internal_use_id == 'duoc.cl' &&
        (teaching_profile.total_hours_not_attended > 0 || totalNotAttended > 0)
      "
      :label="`${$t('matterProgram.matterProgramView.nonAttendanceHours')}:`"
      label-for="input-total_hours_not_attended"
      label-cols="0"
      label-cols-sm="3"
      class="m-0 p-0"
    >
      <div class="d-flex">
        <div class="w-100">
          <b-form-input
            id="input-total_hours_not_attended"
            type="number"
            class="mt-1"
            min="0"
            v-model="$v.teaching_profile.total_hours_not_attended.$model"
            :state="validateState('total_hours_not_attended')"
            aria-describedby="input-total_hours_not_attended-feedback"
            size="sm"
          ></b-form-input>
          <div class="hours-aviable" v-if="maxNotAttendedHours >= 0">
            {{ $t("reusable.common.hoursAvailable") }}:
            <span
              :class="{
                'colorup-hours-available': maxNotAttendedHours > 0,
                'colordown-hours-available': maxNotAttendedHours <= 0,
              }"
              >{{ maxNotAttendedHours > 0 ? maxNotAttendedHours : 0 }}</span
            >
          </div>
          <b-form-invalid-feedback id="input-total_hours_not_attended-feedback">
            {{ $t("reusable.common.mustEnterHourGreaterOrEqualZero") }}
            <span
              v-if="
                teaching_profile.total_hours_not_attended &&
                teaching_profile.total_hours_not_attended > 0
              "
            >
              {{
                $t("reusable.common.cannotExceedHours", {
                  hours:
                    parseFloat(maxNotAttendedHours) +
                    parseFloat(teaching_profile.total_hours_not_attended),
                })
              }}
            </span></b-form-invalid-feedback
          >
        </div>
      </div>
    </b-form-group>
    <b-form-group
      :label="`${$t(
        'matterProgram.matterProgramView.professionalExperienceYears'
      )}:`"
      label-for="input-experience_years"
      label-cols="0"
      label-cols-sm="3"
      class="m-0 p-0"
    >
      <b-form-input
        id="input-experience_years"
        type="number"
        class="mt-1"
        min="0"
        v-model="$v.teaching_profile.experience_years.$model"
        :state="validateState('experience_years')"
        aria-describedby="input-experience_years-feedback"
        size="sm"
      ></b-form-input>

      <b-form-invalid-feedback id="input-experience_years-feedback">
        {{ $t("reusable.common.greaterThanOrEqualToZero") }}
      </b-form-invalid-feedback>
    </b-form-group>
    <b-form-group
      v-if="!isNaN(teaching_profile.id)"
      label-for="input-modification-date"
      label-cols="0"
      label-cols-sm="0"
      class="p-0 m-0 mt-2"
    >
      <ModificationDate :Information="teaching_profile"></ModificationDate>
    </b-form-group>
    <div class="col" style="text-align: right">
      <b-button class="mr-1" size="sm" @click="save">
        {{ $t("reusable.common.save") }}
      </b-button>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { generateUniqueId } from "@/utils/utils";
import { required, minValue, numeric } from "vuelidate/lib/validators";
// import { toast } from "@/utils/utils";
export default {
  name: "TeachingProfileForm",
  components: {
    // NewRichTextEditor: () => import("@/components/reusable/NewRichTextEditor"),
    ModificationDate: () => import("@/components/reusable/ModificationDate"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    ContainerRichTextKlv3: () =>
      import("@/components/reusable/ContainerRichTextKlv3"),
  },
  mixins: [validationMixin],
  props: {
    oldMatter: {
      type: Object,
      required: true,
    },
    TeachingProfile: {
      type: Object,
      default: function () {
        return {
          id: generateUniqueId(),
          professional_title: "",
          specialization: "",
          required_skills: "",
          academic_degree: "",
          work_experience_validity: "",
          experience_years: 0,
          total_hours: 0,
          total_theory_hours: 0,
          total_practical_hours: 0,
          total_hours_not_attended: 0,
          matter: this.oldMatter.id,
          creation_date: null,
          update_date: null,
          created_by: null,
          updated_by: null,
        };
      },
    },
    matter: {
      type: [Object, null],
    },
    teaching_profiles: {
      type: Array,
    },
    show_save_button: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return { teaching_profile: { ...this.TeachingProfile } };
  },
  validations: {
    teaching_profile: {
      experience_years: {
        required,
        numeric,
        minValue: minValue(0),
      },
      total_hours: {
        required,
        numeric,
        minValue: minValue(0),
        isValid() {
          if (
            this.maxTotalHours >= 0 ||
            (this.institution && this.institution.internal_use_id == "duoc.cl")
          )
            return true;
          else return false;
        },
      },
      total_theory_hours: {
        required,
        numeric,
        minValue: minValue(0),
        isValid() {
          if (this.maxTeoryHours >= 0) return true;
          else return false;
        },
      },
      total_practical_hours: {
        required,
        numeric,
        minValue: minValue(0),
        isValid() {
          if (this.maxPracticalHours >= 0) return true;
          else return false;
        },
      },
      total_hours_not_attended: {
        required,
        numeric,
        minValue: minValue(0),
        isValid() {
          if (this.maxNotAttendedHours >= 0) return true;
          else return false;
        },
      },
    },
  },
  computed: {
    ...mapGetters({
      matters: names.MATTERS,
      institution: "getInstitution",
      time_allocations: names.TIME_ALLOCATIONS,
      matter_time_allocations: names.MATTER_TIME_ALLOCATIONS,
      ep_matter_time_allocations: names.EP_MATTER_TIME_ALLOCATIONS,
    }),
    old_matter() {
      if (this.oldMatter)
        return this.matters.find((x) => x.id === this.oldMatter.id);
      else return null;
    },
    matterHours() {
      let list = [];
      this.time_allocations.forEach((element) => {
        if (this.matter && !this.matter.use_matter_values) {
          const matter_hour = this.ep_matter_time_allocations.find(
            (x) =>
              x.egress_profile_matter == this.matter.id &&
              x.time_allocation == element.id
          );
          if (matter_hour)
            list.push({
              id: matter_hour.id,
              time_allocation: matter_hour.time_allocation,
              name: element.name,
              order: element.order,
              uses_module_minutes: element.uses_module_minutes,
              internal_use_id: element.internal_use_id,
              egress_profile_matter: matter_hour.egress_profile_matter,
              counts_towards_credits: matter_hour.counts_towards_credits,
              attendance_requirement: matter_hour.attendance_requirement,
              hours: matter_hour.hours,
              tem_hours:
                parseFloat(this.matter.weeks) > 0
                  ? Math.round(
                      parseFloat(matter_hour.hours) /
                        parseFloat(this.matter.weeks)
                    )
                  : 0,
            });
        } else if (this.old_matter) {
          const matter_hour = this.matter_time_allocations.find(
            (x) =>
              x.matter == this.old_matter.id && x.time_allocation == element.id
          );
          if (matter_hour && this.old_matter)
            list.push({
              id: matter_hour.id,
              time_allocation: matter_hour.time_allocation,
              name: element.name,
              order: element.order,
              uses_module_minutes: element.uses_module_minutes,
              internal_use_id: element.internal_use_id,
              matter: matter_hour.matter,
              counts_towards_credits: matter_hour.counts_towards_credits,
              attendance_requirement: matter_hour.attendance_requirement,
              hours: matter_hour.hours,
              tem_hours:
                parseFloat(this.old_matter.weeks) > 0
                  ? Math.round(
                      parseFloat(matter_hour.hours) /
                        parseFloat(this.old_matter.weeks)
                    )
                  : 0,
            });
        }
      });
      return list;
    },
    totalPedagogical() {
      let count = 0;
      this.matterHours
        .filter((x) => x.uses_module_minutes == true)
        .forEach((element) => {
          if (
            // element.counts_towards_credits &&
            element.hours &&
            element.hours >= 0
          ) {
            count += parseFloat(element.hours);
          }
        });
      return count;
    },
    totalClassHours() {
      let count = 0;
      if (this.institution && this.institution.internal_use_id == "duoc.cl")
        this.matterHours
          .filter(
            (x) =>
              x.uses_module_minutes == true &&
              x.internal_use_id == "duoc_classroom_hours"
          )
          .forEach((element) => {
            if (
              // element.counts_towards_credits &&
              element.hours &&
              element.hours >= 0
            ) {
              count += parseFloat(element.hours);
            }
          });
      return count;
    },
    totalPracticalHours() {
      let count = 0;
      if (this.institution && this.institution.internal_use_id == "duoc.cl")
        this.matterHours
          .filter(
            (x) =>
              x.uses_module_minutes == true &&
              [
                "duoc_lab_hours",
                "duoc_computer_hours",
                "duoc_field_hours",
                "duoc_practice_hours",
              ].includes(x.internal_use_id)
          )
          .forEach((element) => {
            if (
              // element.counts_towards_credits &&
              element.hours &&
              element.hours >= 0
            ) {
              count += parseFloat(element.hours);
            }
          });
      return count;
    },
    totalNotAttended() {
      let count = 0;
      if (this.institution && this.institution.internal_use_id == "duoc.cl")
        this.matterHours
          .filter(
            (x) =>
              x.uses_module_minutes == true &&
              x.internal_use_id == "duoc_ava_hours"
          )
          .forEach((element) => {
            if (
              // element.counts_towards_credits &&
              element.hours &&
              element.hours >= 0
            ) {
              count += parseFloat(element.hours);
            }
          });
      return count;
    },
    maxTotalHours() {
      let max_hours = 0;
      max_hours = this.totalPedagogical;
      let count_hours = 0;
      if (
        this.old_matter &&
        this.old_matter.distribution_teaching_profile_hours
      )
        count_hours = this.teaching_profiles
          .filter((x) => x.id != this.teaching_profile.id)
          .reduce((acc, item) => {
            if (parseFloat(item.total_hours) >= 0)
              return parseFloat(acc) + parseFloat(item.total_hours);
            else return acc;
          }, 0);
      count_hours += parseFloat(this.teaching_profile.total_hours);
      return max_hours - count_hours;
    },
    maxTeoryHours() {
      let max_hours = 0;
      if (this.institution && this.institution.internal_use_id != "duoc.cl") {
        return 0;
      } else {
        max_hours = this.totalClassHours;
      }
      let count_hours = 0;
      if (
        this.old_matter &&
        this.old_matter.distribution_teaching_profile_hours
      )
        count_hours = this.teaching_profiles
          .filter((x) => x.id != this.teaching_profile.id)
          .reduce((acc, item) => {
            if (parseFloat(item.total_theory_hours) >= 0)
              return parseFloat(acc) + parseFloat(item.total_theory_hours);
            else return acc;
          }, 0);
      count_hours += parseFloat(this.teaching_profile.total_theory_hours);
      return max_hours - count_hours;
    },
    maxPracticalHours() {
      let max_hours = 0;
      if (this.institution && this.institution.internal_use_id != "duoc.cl") {
        return 0;
      } else {
        max_hours = this.totalPracticalHours;
      }
      let count_hours = 0;
      if (
        this.old_matter &&
        this.old_matter.distribution_teaching_profile_hours
      )
        count_hours = this.teaching_profiles
          .filter((x) => x.id != this.teaching_profile.id)
          .reduce((acc, item) => {
            if (parseFloat(item.total_practical_hours) >= 0)
              return parseFloat(acc) + parseFloat(item.total_practical_hours);
            else return acc;
          }, 0);
      count_hours += parseFloat(this.teaching_profile.total_practical_hours);
      return max_hours - count_hours;
    },
    maxNotAttendedHours() {
      let max_hours = 0;
      if (this.institution && this.institution.internal_use_id != "duoc.cl") {
        return 0;
      } else {
        max_hours = this.totalNotAttended;
      }
      let count_hours = 0;
      if (
        this.old_matter &&
        this.old_matter.distribution_teaching_profile_hours
      )
        count_hours = this.teaching_profiles
          .filter((x) => x.id != this.teaching_profile.id)
          .reduce((acc, item) => {
            if (parseFloat(item.total_hours_not_attended) >= 0)
              return (
                parseFloat(acc) + parseFloat(item.total_hours_not_attended)
              );
            else return acc;
          }, 0);
      count_hours += parseFloat(this.teaching_profile.total_hours_not_attended);
      return max_hours - count_hours;
    },
  },
  methods: {
    validateState(key) {
      const { $dirty, $error } = this.$v.teaching_profile[key];
      return $dirty ? !$error : null;
    },
    patchProfessionalTitle(object, text) {
      this.teaching_profile.professional_title = text;
    },
    patchSpecialization(object, text) {
      this.teaching_profile.specialization = text;
    },
    patchAcademicDegree(object, text) {
      this.teaching_profile.academic_degree = text;
    },
    patchRequiredSkills(object, text) {
      this.teaching_profile.required_skills = text;
    },
    patchWorkExperienceValidity(object, text) {
      this.teaching_profile.work_experience_validity = text;
    },
    save() {
      this.$v.teaching_profile.$touch();
      if (this.$v.teaching_profile.$anyError) {
        return;
      }
      if (!isNaN(this.teaching_profile.id)) this.updateTeachingProfile();
      else this.createTeachingProfile();
    },
    updateTeachingProfile() {
      this.$emit("updated", this.teaching_profile);
    },
    createTeachingProfile() {
      this.$emit("created", this.teaching_profile);
    },
  },
  created() {},
};
</script>

<style scoped>
.form-description {
  width: calc(100%);
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.875rem;
  min-height: calc(1.5em + 0.5rem + 2px);
  height: auto;
  max-height: 200px;
  overflow: auto;
  padding: 0.2rem 0.5rem;
  line-height: 1.5;
  cursor: pointer;
}
.form-description >>> p {
  margin-bottom: 0.7rem !important;
}
.hours-aviable {
  font-size: 10pt;
}
.colorup-hours-available {
  color: #28a745;
}
.colordown-hours-available {
  color: red;
}
</style>

